import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
  useEffect(() => {
    document.body.classList.add('no-pattern');
    return () => {
      document.body.classList.remove('no-pattern');
    };
  }, []);

  const currentDate = new Date().toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  return (
    <div className="min-h-screen bg-gray-50 pt-32 pb-20 px-4">
    <div className="container mx-auto max-w-4xl">
      <div className="bg-white p-8 rounded-lg shadow-md">
        <h1 className="text-3xl font-bold text-gray-800 mb-6">Privacy Policy – Africa Maritime Conference</h1>
        <p className="text-gray-600 mb-8">Effective Date: 1st June 2025</p>
        
        <p className="mb-6 text-gray-700">
          The Africa Maritime Conference (“we,” “our,” “us”) is committed to protecting the privacy of all participants, speakers, sponsors, and other stakeholders (“you,” “your”) whose personal information we collect in connection with the Conference.
        </p>

        <div className="space-y-6">
          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">1. Information We Collect</h2>
            <p className="text-gray-700">
              We may collect the following personal information for conference purposes:
            </p>
            <ul className="list-disc pl-6 mt-2 space-y-2 text-gray-700">
              <li>Name, job title, and organization</li>
              <li>Contact details (email address, phone number, mailing address)</li>
              <li>Payment and billing information (if applicable)</li>
              <li>Conference registration details and preferences</li>
              <li>Any other information voluntarily provided by you during the registration or participation process</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">2. Purpose of Collection</h2>
            <p className="text-gray-700 mb-2">
              All personal information collected is used solely for the purposes of planning, organizing, managing, and delivering the Africa Maritime Conference. This includes:
            </p>
            <ul className="list-disc pl-6 mt-2 space-y-2 text-gray-700">
              <li>Processing registrations and confirming participation</li>
              <li>Communicating updates, schedules, and conference-related information</li>
              <li>Facilitating networking and session participation during the event</li>
              <li>Managing billing and payment (if applicable)</li>
              <li>Ensuring security and compliance with applicable regulations</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">3. No External Sharing</h2>
            <p className="text-gray-700">
              We do not sell, rent, lease, or otherwise share your personal information with any external parties, except when:
            </p>
            <ul className="list-disc pl-6 mt-2 space-y-2 text-gray-700">
              <li>Required by applicable laws or regulations</li>
              <li>Necessary to comply with a legal process or enforceable government request</li>
              <li>You have given explicit consent for a specific purpose</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">4. Data Retention</h2>
            <p className="text-gray-700">
              We will retain your personal information only for as long as necessary to fulfill the purposes described above or as required by law. After this period, your data will be securely deleted.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">5. Security Measures</h2>
            <p className="text-gray-700">
              We take reasonable administrative, technical, and physical measures to protect your personal information from unauthorized access, use, alteration, or disclosure.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">6. Your Rights</h2>
            <p className="text-gray-700">
              You have the right to request access to, correction of, or deletion of your personal information held by us. To exercise these rights, please contact us using the details below.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">7. Contact Information</h2>
            <p className="text-gray-700">
              If you have any questions about this Privacy Policy or how your personal information is handled, please <Link to="/contact-us" className="text-blue-600 hover:underline">contact us</Link>.
            </p>
          </section>
        </div>
      </div>
    </div>
  </div>
  );
};

export default PrivacyPolicy;
